import { data } from 'jquery';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
// import close from '../icons/closeb.png'

export default function Video() {
    const location = useLocation();
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [errors, setErrors] = useState({});
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        let timer;
    
        if (location.pathname === '/demo-video') {
          setShowModal(true);
        }
    
        return () => {
          if (timer) clearTimeout(timer);
        };
      }, [location.pathname]);

    const handleName = (e) => {
        setName(e.target.value)
    }
    const handleEmail = (e) => {
        setEmail(e.target.value)
    }
    const handlePhone = (e) => {
        setPhone(e.target.value)
    }
    const validateForm = () => {
        let isValid = true;
        const newErrors = {};
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (!name) {
            newErrors.name = "name is required";
            isValid = false;
        }
        if (!email) {
            newErrors.email = "Email is required";
            isValid = false;
        } else if (!emailRegex.test(email)) {
            newErrors.email = "please enter valid email";
            isValid = false;
        }
       
        if (!phone) {
            newErrors.phone = "please is required";
            isValid = false;
        } else if (isNaN(phone)) {
            newErrors.phone = "please enter numbers only";
            isValid = false;
        } else if (phone.length < 10) {
            newErrors.phone = "please enter 10 digit number"
            isValid = false;
        }
        setErrors(newErrors);
        return isValid;
    };

    const handleApi = async (e) => {
        e.preventDefault();
      
        if (validateForm()) {
          try {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('email', email);
            formData.append('phone', phone);
      
            const response = await fetch('https://backend.byteedgelearning.com/recordvideo-api.php', {
              method: 'POST',
              body: formData,
            });
      
            const text = await response.text();
            console.log('API Raw Response:', text);
      
            // ✅ Always close the modal after submission
            setShowModal(false);
      
            // Optional: reset form
            setName('');
            setEmail('');
            setPhone('');
      
          } catch (error) {
            console.error('API error:', error);
            alert('Failed to submit the form.');
          }
        }
      };
      
      
      
      
      
    return (
        <>
        {showModal && (
            <div className="modal-overlay">
                <div className="modal-content">
                    <h3>Get the Demo Video</h3>
                    <form>
                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="back-input">
                                    <input id="name" type="text" name='name' className='frm-cntrl' required value={name} onChange={handleName} />
                                    <label>name</label>
                                    {errors.name && <div className="error">{errors.name}</div>}
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="back-input">
                                    <input id="email" type="email" name="email" className='frm-cntrl' required value={email} onChange={handleEmail} />
                                    <label>email</label>
                                    {errors.email && <div className="error">{errors.email}</div>}
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="back-input">
                                    <input id="phone" type="text" name="phone" className='frm-cntrl' required value={phone} onChange={handlePhone} />
                                    <label>mobile</label>
                                    {errors.phone && <div className="error">{errors.phone}</div>}
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <button className="demo-link" onClick={handleApi} type='submit'><span>submit</span></button>
                            </div>
                        </div>
                    
                    </form>
                    
                </div>
            </div>
        )}
      {/* Your page content here */}
            <div className='video-sec'>
                <div className='container-fluid'>
                    <div className='flex'>
                        <div className='video-item'>
                            <div className='video-heading'>
                                <h4 className='mb-2'>from static docs to dynamic growth byteEDGE transforms knowledge into performance.</h4>
                                <ul className='bullet_points'>
                                    <li><b>unlock organizational knowledge, unleash peak rerformance act:</b> learn how byteEDGE turns buried PPTs, policies, and PDFs into high-impact microlearning videos. </li>
                                    <li><b>performance:</b> build capabilities that improve sales readiness, onboarding speed, and frontline productivity.</li>
                                    <li><b>AI-curated, domain-driven content:</b> go beyond generic courses—create knowledge bursts from your own enterprise knowledge repositories.</li>
                                    <li><b>deliver it where work happens:</b> experience how our mobile-first LXP integrates with tools your teams already use—frictionless and fast.</li>
                                    <li><b>your LMS can't do this:</b> without saying it, you'll see why byteEDGE does what legacy systems were never built for.</li>
                                </ul>
                            </div>
                            <div className='video-name'>
                                <h2 className='text-center'>1 Min – what is byteEDGE</h2>
                                <p className='mb-2'>a crisp introduction to our category-defining knowledge performance system</p>
                                <video controls>
                                
                                    <source src='https://cdn.jwplayer.com/videos/QhwyNoXr-RPZCi6Mj.mp4'></source>
                                </video>
                            </div>
                        </div>
                        <div className='video-item'>
                            <div className='video-heading'>
                               
                                <h4 className='mb-2'>“the one and only platform designed for the “swipe-Generation” of enterprise workforce.</h4>
                                <ul className='bullet_points'>
                                    <li><b>mobile-First, swipe-driven UI:</b> no LMS-like friction. a consumer-grade interface employees actually will love to use. </li>
                                    <li><b>400+ built-in micro-learning courses content library:</b> no more need to have a content library provider. everything your workforce needs and more built in including compliance, digital, leadership, onboarding and more.</li>
                                    <li><b>embedded in flow of work:</b> integrate, and launch while you stay at work. Embed within existing MS Teams, LMS, HRMS, CRM, home grown apps or anything other system that your users use.</li>
                                    <li><b>AI powered hyper personalized and “just-in-time”:</b> instant access to what matters—based on role, location, goals, proficiency levels with in-platform nudging and notifications.</li>
                                    <li><b>built for real-world outcomes:</b> designed to reduce ramp-up time, improve sales readiness, and drive productivity at scale.</li>
                                    <li><b>community + gamification layer:</b> tap into tiktok-style social communities, badges, leaderboards, and knowledge-sharing circles.</li>
                                </ul>
                            </div>
                            <div className='video-name'>
                                <h2 className='text-center mb-3'>pathbreaking knowledge experience platform</h2>
                                <p className='mb-2'>8-min hands-on mobile app walkthrough to re-imagine how people learn</p>
                                <video controls>
                                    <source src='https://cdn.jwplayer.com/videos/oVCehQEf-RPZCi6Mj.mp4'></source>
                                </video>
                            </div>
                        </div>
                        <div className='video-item'>
                            <div className='video-heading'>
                                <h4 className='mb-2'>platform where you can measure, inspect, analyze, and report every learning action—in real time.</h4>
                                <ul className='bullet_points'>
                                    <li><b>real-time learning intelligence:</b> instantly track who’s learning, what’s working, and where capability gaps exist—no lag, no black box.</li>
                                    <li><b>inspect & influence behavior:</b> drill down to user-level actions and intervene proactively with nudges, rewards, or new content.</li>
                                    <li><b>single-click reporting:</b> eliminate the LMS spreadsheet jungle with ready-made visual dashboards built for CHROs and CLOs.</li>
                                    <li><b>prove business value:</b> connect engagement to real performance outcomes with our value realization dashboard.</li>
                                    <li><b>no add-ons needed:</b> all analytics, content controls, and learner insights come built-in—no expensive extensions or integrations.</li>
                                </ul>
                            </div>
                            <div className='video-name'>
                                <h2 className='text-center mb-3'>transforms the way you measure, inspect, analyse, and report every user action—in real time.</h2>
                                <p className='mb-2'> 5-min platform walkthrough | from insight to action in real time</p>
                                <video controls>
                                    <source src='https://cdn.jwplayer.com/videos/gyRB79WU-RPZCi6Mj.mp4'></source>
                                </video>
                            </div>
                        </div>
                        <div className='video-item'>
                            <div className='video-heading'>
                               
                                <h4 className='mb-2'>“watch how byteEDGE transforms static files into cinematic microlearning</h4>
                                <ul className='bullet_points'>
                                    <li><b>4 simple steps. zero bottlenecks:</b>  Upload → AI Script → Visual + Voice → Instant Preview. Anyone can create Netflix-style content.</li>
                                    <li><b>built for enterprise, not entertainment:</b>  unlike flashy consumer AI tools, byteEDGE delivers compliance-ready, multilingual business learning videos.</li>
                                    <li><b>faster@ 1/3rd the cost:</b> no agencies. no delays. just AI efficiency at scale with cinematic polish.</li>
                                    <li><b>consistent quality, global reach:</b> auto-translate in 75+ languages, localize instantly, and push to your frontline—all in-app.</li>
                                    <li><b>empower every function:</b> from HR to sales ops, now anyone can create content that inspires, trains, and drives outcomes</li>         
                                </ul>
                            </div>
                            <div className='video-name'>
                                <h2 className='text-center'>turn boring documents into binge-worthy knowledge micro-videos</h2>
                                <p className='mb-2'> 2-min to see the magic—from document to video in minutes</p>
                                <video controls>
                                    <source src='https://cdn.jwplayer.com/videos/uJqsxoOK-RPZCi6Mj.mp4'></source>
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
